import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-3 row justify-content-center" }
const _hoisted_2 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}
const _hoisted_3 = {
  key: 0,
  controls: "",
  class: "col-12"
}
const _hoisted_4 = ["src"]

import Api from "@/services/api";
    import { Ad, Category } from "@/services/types";
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip, } from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PlaceView',
  setup(__props) {

    const router = useRouter()
    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const place = reactive<Ad>({
        name: '',
        description: ''
    })
    const locating = ref<boolean>(false)
    
    const route = useRoute()
    const id = route.params.id

    const rules = reactive<FormRules<Ad>>({
        name: [{required: true, message: 'Informe seu nome', min: 2}],
        description: [{required: true, message: 'Descreva o local', min: 2}],
        category_id: [{required: true, message: 'Precisa selecionar uma categoria'}],
        "area.name": [{required: true, message: 'Forneça a localizacao'}],
    })

    const categories = reactive<Array<Category>>([])

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (place.area) {
                place.area.lat = position.coords.latitude
                place.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }
    
    const getPlace = async (adId: number) => {
        const res = await Api.get('admin/ads/' + adId)
        console.log(res.data)
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ao prourar este local', {
                type: "error"                
            }).then(() => {
                router.push('/places')
            })
        } else {
            const data = res.data.ad
            place.area = data.area
            place.area_id = data.area_id
            place.category = data.category
            place.category_id = data.category_id
            place.description = data.description
            place.images = data.images
            place.name = data.name
            place.user = data.user
            place.user_id = data.user_id
            place.id = data.id
            place.created_at = data.created_at
            console.log(place.area)
        }
    }

    onBeforeMount(async () => {
        loading.value = true
        
        const res = await Api.get('admin/categories')
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message)
        } else {
            const data = res.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }

        await getPlace(Number(id))
        loading.value = false
    })

    const isVideoFile = (filename: string): boolean => {
        const videoExtensions = [".mp4", ".avi", ".mpeg", ".quicktime", ".webm"];
        return videoExtensions.some(ext => filename.endsWith(ext));
    }

    const onMapClick = (event: LeafletMouseEvent) => {
        const { lat, lng } = event.latlng
        if (place.area) {
            place.area.lat = lat
            place.area.long = lng
        } else {
            place.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(place.area);
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!place.area?.lat || !place.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                saving.value = true
                const data = new FormData()
                data.append('name', place.name)
                data.append('category_id', `${place.category_id}`)
                data.append('description', place.description)
                
                // Area
                if (place.area) {
                    data.append('area[name]', place.area.name)
                    data.append('area[lat]', place.area.lat.toString())
                    data.append('area[long]', place.area.long.toString())
                }
                const res = await Api.put('admin/ads/' + id, place, data)
                console.log(res.data)

                if (res.status == 200) {
                    ElMessage.success({message: 'Dados atualizados com sucesso'})
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        const erros = res.data.errors
                        console.log(formRef.value)
                        formRef.value?.fields.forEach((val) => {
                            console.log(val)
                            Object.keys(erros).forEach(field => {
                                if (val.prop == field) {
                                    val.validateState = "error"
                                    ElMessage({
                                        type: "error",
                                        message: res.data.errors[field][0]
                                    })
                                }
                            })
                        })
                    }
                } else {
                    ElMessage.error({message: "Ocorreu um erro " + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "col-12",
      header: place.id ? place.name:'Procurando local'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          loading: loading.value,
          animated: "",
          rows: 12
        }, {
          default: _withCtx(() => [
            place
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  disabled: saving.value,
                  model: place,
                  "label-position": "top",
                  rules: rules,
                  ref_key: "formRef",
                  ref: formRef
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { gutter: 30 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          sm: 24,
                          md: 12,
                          lg: 10
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "Nome",
                              prop: "name"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  name: "name",
                                  modelValue: place.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((place.name) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Categoria",
                              prop: "category_id"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: place.category_id,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((place.category_id) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories, (c) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: c.name,
                                        value: c.id,
                                        key: c.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(c.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Descricao do local",
                              prop: "description"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "textarea",
                                  name: "description",
                                  modelValue: place.description,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((place.description) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "Cadastrado por" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(place.user?.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "Adicionado em",
                              prop: "created_at"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(new Date(place.created_at).toLocaleString()), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, {
                          sm: 24,
                          md: 12,
                          lg: 14
                        }, {
                          default: _withCtx(() => [
                            (place.area)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "Local",
                                  prop: "area.name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      name: "area",
                                      modelValue: place.area.name,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((place.area.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_el_button, {
                                plain: "",
                                class: "position-absolute end-0",
                                style: {"z-index":"1024"},
                                loading: locating.value || loading.value,
                                size: "large",
                                type: "success",
                                onClick: _withModifiers(locate, ["prevent"])
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode(" Localizar-me ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["loading"]),
                              (place.area)
                                ? (_openBlock(), _createBlock(_unref(LMap), {
                                    key: 0,
                                    onContextmenu: onMapClick,
                                    ref: "map",
                                    zoom: 16,
                                    center: [place.area.lat, place.area.long]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(LTileLayer), {
                                        url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                                        "layer-type": "base",
                                        name: "OpenStreetMap"
                                      }),
                                      (place.area)
                                        ? (_openBlock(), _createBlock(_unref(LMarker), {
                                            key: 0,
                                            "lat-lng": [place.area.lat, place.area.long]
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(LTooltip), null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(place.name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["lat-lng"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["center"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "model", "rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, {
              justify: "end",
              class: "py-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (submit(formRef.value))),
                      plain: "",
                      loading: saving.value
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" Salvar alterações ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, null, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("h6", null, "Galeria", -1)),
                _createVNode(_component_el_divider)
              ]),
              _: 1
            }),
            (typeof place.images[0] == 'object')
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 1,
                  gutter: 20
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(place.images, (img) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        sm: 6,
                        md: 4,
                        key: img.id
                      }, {
                        default: _withCtx(() => [
                          (isVideoFile(img.url))
                            ? (_openBlock(), _createElementBlock("video", _hoisted_3, [
                                _createElementVNode("source", {
                                  src: `${_unref(Api).publicUrl}images/ads/${img.url}`
                                }, null, 8, _hoisted_4)
                              ]))
                            : (_openBlock(), _createBlock(_component_el_image, {
                                key: 1,
                                alt: "",
                                src: `${_unref(Api).publicUrl}images/ads/${img.url}`,
                                class: "col-12"
                              }, null, 8, ["src"]))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["header"])
  ]))
}
}

})